import React from "react"
import './SortFilter.scss'
import { RiArrowDownSLine } from "react-icons/ri";

export function SortFilter({setSelected}) {

    return (
        <div className="overlay active">
            <div className="drawer bottom  active">
                <div className="popup-content bottom">
                    <ul className="list">
                        <li className="sortby" >
                        <RiArrowDownSLine onClick={() => setSelected(0)} />
                        </li>
                        <span>
                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Popularity</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>

                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Latest</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>

                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Discount</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>

                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Price: High To Low</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>

                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Price: Low To High</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>

                            <li>
                                <div className="ripple-container ">
                                    <button className=" default">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill-rule="nonzero"
                                            d="M14.85 2.14v11.71a1 1 0 0 1-1 1H2.14a1 1 0 0 1-1-1V2.14a1 1 0 0 1 1-1h11.71a1 1 0 0 1 1 1zM14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0z"
                                        ></path>
                                    </svg>
                                        <span className="sortByValues"> Customer Rating</span></button>
                                    <div className="ripple"></div>
                                </div>
                            </li>
                        </span>
                    </ul>
                </div>
            </div>
        </div>
    )
}